import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const ButtonPlusIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessibilityRole="image" viewBox="0 0 37 36" focusable={false} tabIndex="-1">
                <Path
                    d="M8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19V17ZM29 19C29.5523 19 30 18.5523 30 18C30 17.4477 29.5523 17 29 17V19ZM8 19H29V17H8V19ZM17.5004 6L17.5004 30H19.5004L19.5004 6L17.5004 6Z"
                    fill={fill ?? Color.ALMOST_BLACK}
                    // @ts-ignore
                    tabIndex="-1"
                />
            </Svg>
        </View>
    );
};
